module.exports = __webpack_public_path__ + "img/Troja-restaurant-1.ca45d6d6.jpg";